export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/identity.js
// module id = PSpO
// module chunks = 0